import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  message: '',
}

const footerSlice = createSlice({
  name: 'footer',
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload
    },
  },
})

export const { setMessage } = footerSlice.actions

export default footerSlice.reducer
